import React from "react";
import { ArrowUpRightIcon, QuoteIcon, StarIcon } from "lucide-react";
import { business } from "../../data/business";
import { SectionHeading } from "../ui/SectionHeading";

// [[FILL IN — real Google reviews only. Never fabricate reviews.]]
const reviewSlots = [1, 2, 3];
export function Testimonials() {
  return <section aria-labelledby="reviews-title" className="section-y gutter bg-white" data-id="element-278" data-mp="2hto3leenhjk7">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-279" data-mp="3fgn2lvstf3l9">
        <SectionHeading id="reviews-title" eyebrow="In families' words" title="Trusted when it matters most." data-id="element-280" data-mp="3agsbps91ie07" />
        <a href={business.googleReviewsUrl} target="_blank" rel="noopener noreferrer" className="group inline-flex min-h-[48px] shrink-0 items-center gap-2 font-semibold text-navy hover:text-gold-hover" data-id="element-281" data-mp="35hfkywf1smsc">
          Read our reviews on Google
          <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-282" data-mp="1q174dbgfj2a5" />
        </a>
      </div>

      <ul className="mt-14 grid gap-5 md:grid-cols-3 ultra:gap-8" data-id="element-283" data-mp="34a43fh90av6y">
        {reviewSlots.map(n => <li key={n} className="flex min-h-[18rem] flex-col rounded-3xl border border-dashed border-navy/20 bg-sand/60 p-8" data-id="element-284" data-mp="2qackr37joqmm">
            <QuoteIcon className="h-8 w-8 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-285" data-mp="2ua3dhcgmtgts" />
            <p className="mt-6 font-serif text-2xl text-navy/70" data-id="element-286" data-mp="2giyl8vflfqth">Review coming soon</p>
            <p className="mt-2 text-sm text-muted" data-id="element-287" data-mp="2lazu07djyzer">Verified Google reviews will appear here.</p>
            <div className="mt-auto flex gap-1 pt-8" aria-hidden="true" data-id="element-288" data-mp="26mlkxepjmepr">
              {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-4 w-4 text-navy/20" strokeWidth={1.5} data-id="element-289" data-mp="2blorx4p32v0d" />)}
            </div>
          </li>)}
      </ul>
    </section>;
}